module.exports = __webpack_public_path__ + "img/85per.632d8486.svg";